export class AppError extends Error {
  readonly code: string;
  readonly name: string = 'Unknown Error';
  readonly message: string = 'An unknown error occurred, please refresh page and try again.';

  constructor(name?: string, message?: string, code?: string) {
    super(message);

    if (name) {
      this.name = name;
    }

    if (message) {
      this.message = message;
    }

    if (code) {
      this.code = code;
    }
  }
}
